export interface Connection { baseUrl: string; game?: string; token?: string; }
export function createApi(connection:Connection, transport:typeof fetch=fetch){
  const base=new URL(connection.baseUrl);
  if(base.search||base.hash||base.username||base.password)throw new Error('Базовый URL не должен содержать токен или параметры.');
  return async function api(path:string,body?:unknown){
    const url=new URL(base.href.replace(/\/$/,'')+'/api/'+path);
    if(connection.game)url.searchParams.set('game',connection.game);
    const headers:Record<string,string>={};
    if(connection.token)headers.Authorization=`Bearer ${connection.token}`;
    if(body!==undefined)headers['Content-Type']='application/json';
    const response=await transport(url,{method:body===undefined?'GET':'POST',headers,body:body===undefined?undefined:JSON.stringify(body),signal:AbortSignal.timeout(12000),redirect:'error',cache:'no-store'});
    const data=await response.json();
    if(!response.ok)throw Object.assign(new Error(data.errors?.join('\n')||data.error||`Ошибка ${response.status}`),{errors:data.errors,status:response.status});
    return data;
  };
}
